export default "__VITE_PUBLIC_ASSET__04149e90__"